<div class="fax-filter-list-form">
  <input
    name="faxFilterListFormValue"
    [placeholder]="placeholder"
    [formControl]="valueFormControl"
    [readOnly]="readOnly"
    class="form-input fax-filter-list-form__input"
  />

  <div class="fax-filter-list-form__buttons">
    <button class="icon-btn icon-btn_md" [disabled]="isCreateDisabled" (click)="onCreateClick()">
      <img src="assets/icons/plus.svg" alt="Add filter" />
    </button>

    <button class="icon-btn icon-btn_md" [disabled]="isValueEmpty" (click)="onDeleteClick()">
      <img src="assets/icons/subtract.webp" alt="Delete filter" />
    </button>
  </div>
</div>
